import './cookie-consent';

import loadNavbar from './navbar/index.js';
import loadTabMovement from './tabMovement/index.js';

loadNavbar();
loadTabMovement();
